import { TRAINING_VIEW_LABELS } from '../../../../lib/constants/labelKeys';
import { useViewContext } from '../../../../lib/context/ViewContext';
import { AemLearningDetailsBaseProps } from '../../../../lib/types/aemDataModels';
import { Api } from '../../../../lib/types/apiSpec';
import { isNil } from '../../../../lib/utils/isNil';
import PureLink from '../../../common/Link/PureLink';
import BaseLearningDetails from '../../base/BaseLearningDetails/BaseLearningDetails';
import { Label } from '../../../common/Label/Label';
import Button from '../../../common/Button/Button';
import styles from '../../base/BaseLearningDetails/BaseLearningDetails.module.scss';

const DocumentDetails = (props: AemLearningDetailsBaseProps<Api.DocumentLibrary>) => {
  const { page, isLoading } = useViewContext();
  const { document, error } = page;

  if (isNil(document) && !isLoading && !error) {
    return null;
  }

  return (
    <BaseLearningDetails<Api.DocumentLibrary>
      {...props}
      data={document}
      isLoading={!!isLoading}
      error={error}
      button={
        <PureLink href={document?.assetReference} className={styles.downloadAssetAnchor} tabBehaviour="forceNewTab">
          <Button className={styles.downloadAssetButton}>
            <Label name={TRAINING_VIEW_LABELS.DOWNLOAD_ASSET_BUTTON} />
          </Button>
        </PureLink>
      }
    />
  );
};

export default DocumentDetails;
